import styled, { css } from 'styled-components'

import Box from '../Box'
import Button from '../Button'
import colors from '../../constants/colors'

import { DropdownContentProps, DropdownItemComponent, DropdownItemProps } from './Dropdown.types'

export const StyledDropdownContent = styled(Box)<DropdownContentProps>`
  display: ${(props) => (props.isShow ? 'block' : 'none')};
  position: absolute;
  right: ${(props) => props.positionDropdown === 'right' && '0'};
  left: ${(props) => props.positionDropdown === 'left' && '0'};
  ${(props) =>
    props.positionDropdown === 'center' &&
    css`
      left: 50%;
      transform: translateX(-50%);
    `}
  min-width: ${(props) => (props.overrideWidth ? 'unset' : '160px')};
  background-color: ${colors.white};
  border-radius: 8px;
  padding: 4px 0;
  box-shadow: 0px 4px 10px rgba(20, 20, 32, 0.08);
  width: max-content;
  z-index: 1;
`

export const StyledDropdownItem: DropdownItemComponent = styled.button.attrs(() => ({
  type: 'button',
}))<DropdownItemProps>`
  padding: 4px 16px;
  cursor: pointer;
  border: none;
  background-color: ${(props) => (props.isActive ? colors.black5 : 'unset')};
  display: flex;
  width: 100%;
  text-align: left;

  &:hover {
    background-color: ${colors.black5};
  }
`
export const StyledToggleButton = styled(Button)`
  margin-bottom: 4px;
`
